(() => {
  const MOBILE_MAX = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function setState(block, open) {
    const heading = block.querySelector('.footer-block__heading');
    const content = block.querySelector('.footer-block__details-content');
    if (!heading || !content) return;

    block.classList.toggle('is-open', open);
    heading.setAttribute('aria-expanded', String(open));

    if (isMobile()) {
      content.hidden = !open;
    } else {
      content.hidden = false;
    }
  }

  function bindBlock(block) {
    if (block.dataset.ttFooterCollapseBound === 'true') return;

    const heading = block.querySelector('.footer-block__heading');
    const content = block.querySelector('.footer-block__details-content');
    if (!heading || !content) return;

    block.dataset.ttFooterCollapseBound = 'true';
    block.classList.add('tt-footer-collapsible');

    if (!content.id) {
      content.id = `FooterBlockContent-${Math.random().toString(36).slice(2, 10)}`;
    }

    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-controls', content.id);

    setState(block, !isMobile());

    const toggle = () => {
      if (!isMobile()) return;
      setState(block, !block.classList.contains('is-open'));
    };

    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });
  }

  function bind(root = document) {
    root.querySelectorAll('.footer .footer-block.grid__item').forEach(bindBlock);
  }

  function syncAll() {
    document.querySelectorAll('.footer .footer-block.grid__item.tt-footer-collapsible').forEach((block) => {
      if (!isMobile()) {
        setState(block, true);
      } else if (!block.classList.contains('is-open')) {
        setState(block, false);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bind(document);
    syncAll();
  });

  document.addEventListener('shopify:section:load', (event) => {
    bind(event.target);
    syncAll();
  });

  window.addEventListener('resize', () => {
    window.requestAnimationFrame(syncAll);
  });
})();
